import { resourceItems } from '@/mocks/home';
import { useDemoToast } from '@/components/feature/DemoToast';
import SectionHeading from './SectionHeading';

export default function ResourceSection() {
  const { show } = useDemoToast();

  return (
    <section id="resource" className="hll-scroll-anchor w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="DOWNLOAD CENTER"
          title="资源下载 · 高清原件直接拿"
          desc="黑料吃瓜网资源下载区按文件形态列好格式、体积与画质，黑料吃瓜网高清原图与 4K 原档都在这里，取用一目了然。"
        />

        <div className="mt-8 overflow-hidden rounded-lg border border-background-300/60 bg-background-50">
          <div className="hidden grid-cols-12 gap-4 border-b border-background-200 bg-background-100 px-6 py-3 text-xs text-foreground-500 md:grid">
            <span className="col-span-6">资源名称</span>
            <span className="col-span-2">格式 / 体积</span>
            <span className="col-span-2">画质</span>
            <span className="col-span-2 text-right">操作</span>
          </div>

          <div className="divide-y divide-background-200">
            {resourceItems.map((item) => (
              <div
                key={item.id}
                className="grid grid-cols-1 gap-3 px-4 py-5 transition-colors hover:bg-background-100 md:grid-cols-12 md:items-center md:gap-4 md:px-6"
              >
                <div className="flex items-center gap-3 md:col-span-6">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className="ri-file-zip-line text-xl"></i>
                  </span>
                  <div className="min-w-0">
                    <p className="truncate font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.title}
                    </p>
                    <p className="mt-1 text-xs text-foreground-500">{item.updated}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-700 md:col-span-2">
                  <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">{item.format}</span>
                  <span>{item.size}</span>
                </div>
                <div className="text-xs text-foreground-700 md:col-span-2">
                  <span className="inline-flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                      <i className="ri-hd-line text-sm"></i>
                    </span>
                    {item.quality}
                  </span>
                </div>
                <div className="md:col-span-2 md:text-right">
                  <button
                    type="button"
                    onClick={() => show(`「${item.title}」已加入下载清单（演示）`)}
                    className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-900 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 md:w-auto"
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-download-2-line text-base"></i>
                    </span>
                    下载
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-foreground-500">
          下载入口为展示效果，实际取用以站内说明为准。
        </p>
      </div>
    </section>
  );
}